theme.SlideShow = (function () {
	// CRITICAL: Prevent any mobile zoom BEFORE anything else initializes
	if (window.innerWidth < 750) {
		// Force viewport settings and monitor for changes
		function enforceViewport() {
			let viewport = document.querySelector('meta[name="viewport"]');
			if (viewport) {
				viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no');
			}
		}

		enforceViewport();

		// Detect zoom by monitoring visualViewport
		if (window.visualViewport) {
			let initialScale = window.visualViewport.scale;
			window.visualViewport.addEventListener('resize', function () {
				// If scale changed from initial, reset it
				if (Math.abs(window.visualViewport.scale - initialScale) > 0.01) {
					enforceViewport();
					// Force reload viewport by changing and changing back
					let viewport = document.querySelector('meta[name="viewport"]');
					if (viewport) {
						let content = viewport.getAttribute('content');
						viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
						setTimeout(() => {
							viewport.setAttribute('content', content);
						}, 10);
					}
				}
			});
		}

		// Prevent gesture events (iOS)
		['gesturestart', 'gesturechange', 'gestureend'].forEach(function (eventName) {
			document.addEventListener(
				eventName,
				function (e) {
					e.preventDefault();
					e.stopPropagation();
				},
				{ passive: false }
			);
		});

		// Prevent multi-touch
		document.addEventListener(
			'touchstart',
			function (e) {
				if (e.touches.length > 1) {
					e.preventDefault();
				}
			},
			{ passive: false }
		);

		document.addEventListener(
			'touchmove',
			function (e) {
				if (e.touches.length > 1) {
					e.preventDefault();
				}
			},
			{ passive: false }
		);
	}

	function Slider(e) {
		let slideshow = e.querySelector('.slideshow__wrapper'),
			paginationSelector = e.querySelector('.swiper-pagination'),
			navselectorPrev = e.querySelector('.swiper-button-prev'),
			navselectorNext = e.querySelector('.swiper-button-next'),
			autoplaySelctor = e.dataset.sliderAutoplay,
			autoplayInit = false,
			autoPlayDelay = parseInt(e.dataset.sliderDelay),
			loopSelector = e.dataset.sliderLoop,
			loopInit = false,
			slidePagination = e.dataset.pagination,
			paginatinInit = 'bullets';

		// Detect mobile and use appropriate transition settings
		const isMobile = window.innerWidth < 750;
		let transitionEffect, transitionSpeed;

		if (isMobile && e.dataset.transitionEffectMobile) {
			transitionEffect = e.dataset.transitionEffectMobile;
			transitionSpeed = parseInt(e.dataset.transitionSpeedMobile) || 1000;
		} else {
			transitionEffect = e.dataset.transitionEffect || 'fade';
			transitionSpeed = parseInt(e.dataset.transitionSpeed) || 1500;
		}

		// Ensure the DOM reflects the active transition mode (desktop vs mobile).
		// Liquid may have rendered a server-side `data-vertical-slides` flag; override it at runtime
		// so mobile doesn't accidentally receive desktop vertical styling.
		try {
			if (slideshow) {
				if (transitionEffect === 'slide-vertical') {
					slideshow.setAttribute('data-vertical-slides', 'true');
				} else {
					slideshow.setAttribute('data-vertical-slides', 'false');
				}
			}
		} catch (err) {
			console.warn('Could not set data-vertical-slides on slideshow element', err);
		}

		if (autoplaySelctor == 'true') {
			autoplayInit = { delay: autoPlayDelay };
		}
		if (loopSelector == 'true') {
			loopInit = true;
		}

		if (slidePagination == 'counter') {
			paginatinInit = 'fraction';
		}

		// Base configuration
		var swiperConfig = {
			loop: loopInit,
			slidesPerView: 1, // Always show exactly 1 slide at a time
			spaceBetween: 0, // No space between slides
			centeredSlides: true, // Center the active slide
			pagination: {
				el: paginationSelector,
				clickable: false, // Disable built-in pagination clicks - custom handlers manage this
				type: paginatinInit,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + '</span>';
				},
			},
			autoplay: autoplayInit,
			// Enable autoHeight to recalculate height on slide change
			autoHeight: true,
			speed: transitionSpeed,
			// Navigation is handled by custom click handlers to enable pre-fade animation
			// Do not pass nextEl/prevEl to Swiper to avoid double navigation
			navigation: false,
			// Disable zoom functionality to prevent mobile zoom-out
			zoom: false,
			// Prevent touch gestures from zooming
			touchEventsTarget: 'container',
		};

		// Apply transition effect based on selection
		switch (transitionEffect) {
			case 'fade':
				swiperConfig.effect = 'fade';
				swiperConfig.fadeEffect = {
					crossFade: true,
				};
				break;

			case 'slide-vertical':
				swiperConfig.direction = 'vertical';
				swiperConfig.effect = 'slide';
				swiperConfig.speed = transitionSpeed;
				break;

			case 'cube':
				swiperConfig.effect = 'cube';
				swiperConfig.cubeEffect = {
					shadow: true,
					slideShadows: true,
					shadowOffset: 20,
					shadowScale: 0.94,
				};
				break;

			case 'flip':
				swiperConfig.effect = 'flip';
				swiperConfig.flipEffect = {
					slideShadows: true,
					limitRotation: true,
				};
				break;

			case 'coverflow':
				swiperConfig.effect = 'coverflow';
				swiperConfig.coverflowEffect = {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: true,
				};
				break;

			case 'zoom-in':
				swiperConfig.effect = 'creative';
				swiperConfig.creativeEffect = {
					prev: {
						translate: [0, 0, -400],
						scale: 0.5,
						opacity: 0,
					},
					next: {
						translate: [0, 0, 0],
						scale: 0.5,
						opacity: 0,
					},
				};
				break;

			case 'zoom-out':
				swiperConfig.effect = 'creative';
				swiperConfig.creativeEffect = {
					prev: {
						translate: [0, 0, 400],
						scale: 1.5,
						opacity: 0,
					},
					next: {
						translate: [0, 0, 0],
						scale: 1.5,
						opacity: 0,
					},
				};
				break;

			case 'creative-rotate':
				swiperConfig.effect = 'creative';
				swiperConfig.creativeEffect = {
					prev: {
						translate: ['-120%', 0, -500],
						rotate: [0, 0, -45],
						opacity: 0,
					},
					next: {
						translate: ['120%', 0, -500],
						rotate: [0, 0, 45],
						opacity: 0,
					},
				};
				break;

			case 'slide':
			default:
				swiperConfig.effect = 'slide';
				swiperConfig.direction = 'horizontal';
				break;
		}

		var swiper = new Swiper(slideshow, swiperConfig);

		// Helper to update height with animation (uses configured speed)
		function updateHeightAnimated(delay) {
			var duration = swiperConfig.speed || 300;
			if (!swiper || !swiper.updateAutoHeight) return;
			// Optionally delay a bit to let browser layout settle
			setTimeout(function () {
				try {
					swiper.updateAutoHeight(duration);
					// Also ensure the outer section/container (`e`) matches the new swiper height
					// but only for non-vertical slides (vertical uses fixed heights)
					if (slideshow && e && swiperConfig.direction !== 'vertical') {
						try {
							var newH = Math.ceil(slideshow.getBoundingClientRect().height);
							// Apply transition to the section so changes animate
							e.style.transition = 'height ' + duration + 'ms ease-in-out';
							e.style.height = newH + 'px';
							// remove explicit height after a timeout to allow natural flow (keep min-height behavior)
							setTimeout(function () {
								// Return to natural height so the section doesn't retain excess space
								e.style.height = 'auto';
							}, duration + 60);
						} catch (err) {
							// ignore measurement errors
						}
					}
				} catch (err) {
					console.warn('updateAutoHeight failed', err);
				}
			}, delay || 20);
		}

		// Initial height update after init
		updateHeightAnimated(50);

		// Listen for media load events inside slides so height recalculates when images/videos finish loading
		if (slideshow) {
			var mediaEls = slideshow.querySelectorAll('img, video, iframe');
			mediaEls.forEach(function (media) {
				if (media.tagName.toLowerCase() === 'img') {
					if (media.complete) {
						updateHeightAnimated(30);
					} else {
						media.addEventListener('load', function () {
							updateHeightAnimated(30);
						});
					}
				} else if (media.tagName.toLowerCase() === 'video') {
					media.addEventListener('loadedmetadata', function () {
						updateHeightAnimated(30);
					});
					media.addEventListener('loadeddata', function () {
						updateHeightAnimated(30);
					});
				} else {
					// iframes
					media.addEventListener('load', function () {
						updateHeightAnimated(30);
					});
				}
			});

			// Observe DOM changes inside slideshow (e.g., dynamic text/button changes) and update height
			try {
				var mo = new MutationObserver(function () {
					updateHeightAnimated(40);
				});
				mo.observe(slideshow, { childList: true, subtree: true, characterData: true });
			} catch (err) {
				// MutationObserver not supported or failed - ignore
			}
		}

		// Safeguard: when using vertical slide effect, keep Swiper's direction locked
		if (swiperConfig.direction === 'vertical') {
			// Ensure params.direction remains vertical in case Swiper manipulates it during loop/clones
			swiper.params.direction = 'vertical';
			// Add runtime listener to reapply if needed during transitions
			swiper.on('slideChangeTransitionStart', function () {
				if (swiper.params.direction !== 'vertical') {
					swiper.params.direction = 'vertical';
				}
				// make sure wrapper keeps vertical data attribute/class so CSS continues to apply
				if (slideshow && !slideshow.classList.contains('navigation--direction-vertical')) {
					slideshow.classList.add('navigation--direction-vertical');
				}
			});
		}

		// Mobile nav placement is controlled by CSS using data-mobile-nav-placement

		// Mobile animation class management - animate on each slide change
		function handleMobileSlideAnimation() {
			const isMobileScreen = window.innerWidth < 750;
			if (!isMobileScreen) return;

			// Remove animation classes from all slides
			slideshow.querySelectorAll('.swiper-slide').forEach(function (slide) {
				slide.classList.remove('slide--animating');
				slide.classList.remove('slide--animated');
			});

			// Get current active slide
			const activeSlide = swiper.slides[swiper.activeIndex];
			if (!activeSlide) return;

			// Trigger animation for current slide
			activeSlide.classList.add('slide--animating');
			// After animation completes, mark as animated
			setTimeout(function () {
				activeSlide.classList.add('slide--animated');
			}, 500); // 0.3s text + 0.2s buffer
		}

		// Trigger mobile animation on slide change
		swiper.on('slideChangeTransitionEnd', handleMobileSlideAnimation);

		// Also trigger for initial slide on load
		setTimeout(handleMobileSlideAnimation, 100);

		// Update height on slide change to ensure proper sizing
		swiper.on('slideChange', function () {
			if (swiperConfig.autoHeight) {
				// update with a tiny delay to allow slide DOM to finish updates
				updateHeightAnimated(40);
				// also schedule a follow-up to catch late layout changes
				setTimeout(function () {
					updateHeightAnimated(120);
				}, 250);
			}
			// Schedule next autoplay fade-out for the new active slide
			if (swiper.params.autoplay && swiper.params.autoplay.delay) {
				if (slideshow.__fadeOutTimer) clearTimeout(slideshow.__fadeOutTimer);
				// Start fading early enough so fade fully completes before transition starts
				const fadeDuration = 1200; // must match CSS
				const buffer = 300; // safety before transition begins
				const lead = fadeDuration + transitionSpeed + buffer;
				const delay = Math.max(0, swiper.params.autoplay.delay - lead);
				slideshow.__fadeOutTimer = setTimeout(() => {
					fadeOutCurrentSlide();
				}, delay);
			}
		});

		// Also update on transition end to ensure accurate height
		swiper.on('transitionEnd', function () {
			if (swiperConfig.autoHeight) {
				// Use the configured speed so height change is animated smoothly
				updateHeightAnimated(10);
				// ensure final layout is correct after animation
				setTimeout(function () {
					updateHeightAnimated(10);
				}, (swiperConfig.speed || 300) + 50);
			}
		});

		function fadeOutCurrentSlide() {
			if (slideshow.__fadingNow) return;
			slideshow.__fadingNow = true;
			slideshow.classList.add('slideshow--fade-out');
			const activeEl = swiper && Number.isInteger(swiper.activeIndex) ? swiper.slides[swiper.activeIndex] : slideshow.querySelector('.swiper-slide-active');
			if (activeEl) activeEl.classList.add('slide--fade-out');
		}

		// Autoplay fade-out: when timer is about to finish, fade out current slide content
		if (swiper.params.autoplay) {
			swiper.on('autoplayTimeLeft', function (_s, time, progress) {
				// Trigger fade when time left equals fade window + transition speed + buffer
				const fadeDuration = 1200;
				const buffer = 300;
				const threshold = fadeDuration + transitionSpeed + buffer;
				const resetThreshold = threshold + 300;
				if (time <= threshold && !slideshow.__fadeOutArmed) {
					slideshow.__fadeOutArmed = true;
					fadeOutCurrentSlide();
				}
				if (time > resetThreshold) {
					slideshow.__fadeOutArmed = false;
				}
			});
			// At transition start: remove wrapper flag, keep previous slide faded until end
			swiper.on('slideChangeTransitionStart', function () {
				slideshow.classList.remove('slideshow--fade-out');
				// clear timer/state
				if (slideshow.__fadeOutTimer) clearTimeout(slideshow.__fadeOutTimer);
				slideshow.__fadingNow = false;
			});
			// After transition, cleanup the previous slide flag
			swiper.on('slideChangeTransitionEnd', function () {
				slideshow.querySelectorAll('.swiper-slide.slide--fade-out').forEach((s) => s.classList.remove('slide--fade-out'));
			});
		}

		// Always pre-fade on manual navigation (even if autoplay is enabled)
		// On mobile: skip fade-out, navigate immediately, then fade-in new slide content
		// On desktop: keep fade-out behavior before navigation
		(function attachManualFadeNav() {
			const isMobileNav = window.innerWidth < 750;

			const maybeFadeThen = (cb) => {
				if (slideshow.__manualNavPending) return; // guard against double triggers
				slideshow.__manualNavPending = true;

				// Mobile: navigate immediately without fade-out delay
				if (isMobileNav) {
					try {
						cb();
					} finally {
						slideshow.__manualNavPending = false;
					}
					return;
				}

				// Desktop: fade out current slide first, then navigate
				fadeOutCurrentSlide();
				const fadeDuration = 1200;
				setTimeout(() => {
					try {
						cb();
					} finally {
						slideshow.__manualNavPending = false;
					}
				}, fadeDuration);
			};
			if (navselectorNext) {
				navselectorNext.addEventListener('click', function (ev) {
					ev.preventDefault();
					ev.stopPropagation();
					ev.stopImmediatePropagation();
					maybeFadeThen(() => swiper.slideNext());
				});
			}
			if (navselectorPrev) {
				navselectorPrev.addEventListener('click', function (ev) {
					ev.preventDefault();
					ev.stopPropagation();
					ev.stopImmediatePropagation();
					maybeFadeThen(() => swiper.slidePrev());
				});
			}
			if (paginationSelector) {
				paginationSelector.addEventListener('click', function (ev) {
					const bullet = ev.target.closest('.swiper-pagination-bullet');
					if (!bullet) return; // let other clicks pass
					ev.preventDefault();
					ev.stopPropagation();
					ev.stopImmediatePropagation();
					const bullets = paginationSelector.querySelectorAll('.swiper-pagination-bullet');
					const index = Array.prototype.indexOf.call(bullets, bullet);
					maybeFadeThen(() => (typeof swiper.slideToLoop === 'function' ? swiper.slideToLoop(index) : swiper.slideTo(index)));
				});
			}
			// Reset the manual guard at transition start just in case
			swiper.on('slideChangeTransitionStart', function () {
				slideshow.__manualNavPending = false;
			});
		})();

		// Handle resize to switch between mobile and desktop transitions
		let resizeTimer;
		let wasMobile = isMobile; // Track previous state

		window.addEventListener('resize', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () {
				const isNowMobile = window.innerWidth < 750;

				// Only reinitialize if crossing the mobile/desktop breakpoint
				if (wasMobile !== isNowMobile && swiper) {
					swiper.destroy(true, true);
					wasMobile = isNowMobile; // Update tracked state
					// Reinitialize with new settings
					setTimeout(() => {
						// Update data-vertical-slides before reinit based on new viewport
						const willUseMobile = window.innerWidth < 750;
						let newEffect = willUseMobile && e.dataset.transitionEffectMobile ? e.dataset.transitionEffectMobile : e.dataset.transitionEffect;
						try {
							if (newEffect === 'slide-vertical') {
								e.querySelector('.slideshow__wrapper').setAttribute('data-vertical-slides', 'true');
							} else {
								e.querySelector('.slideshow__wrapper').setAttribute('data-vertical-slides', 'false');
							}
						} catch (err) {
							/* ignore */
						}
						// Re-init slideshow with new settings
						new theme.SlideShow(e);
					}, 100);
				}
			}, 250);
		});

		// Text Animation Handler (Desktop Only)
		(function textAnimationModule() {
			let typewriterTimers = [];
			let prepared = false;

			function clearTimers() {
				typewriterTimers.forEach((t) => clearTimeout(t));
				typewriterTimers = [];
			}

			function prepareParagraph(el) {
				if (!el || el.__typewriterPrepared) return;
				// Preserve original HTML for reset
				el.__originalHTML = el.innerHTML;

				// Helper function to check if a character is Arabic/RTL
				// Arabic Unicode range: \u0600-\u06FF, \u0750-\u077F, \u08A0-\u08FF
				// Arabic Extended ranges and Hebrew: \u0590-\u05FF
				function isArabicChar(ch) {
					const code = ch.charCodeAt(0);
					return (
						(code >= 0x0600 && code <= 0x06ff) || // Arabic
						(code >= 0x0750 && code <= 0x077f) || // Arabic Supplement
						(code >= 0x08a0 && code <= 0x08ff) || // Arabic Extended-A
						(code >= 0x0590 && code <= 0x05ff) || // Hebrew
						(code >= 0xfb50 && code <= 0xfdff) || // Arabic Presentation Forms-A
						(code >= 0xfe70 && code <= 0xfeff)
					); // Arabic Presentation Forms-B
				}

				// Check if text contains any Arabic characters
				function containsArabic(text) {
					for (let i = 0; i < text.length; i++) {
						if (isArabicChar(text[i])) return true;
					}
					return false;
				}

				// Detect iPad/tablet (768px - 1024px width range or iPad user agent)
				function isTablet() {
					const isIPad = /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document;
					const isTabletWidth = window.innerWidth >= 768 && window.innerWidth <= 1024;
					return isIPad || isTabletWidth;
				}

				// Check if any text content contains Arabic
				const fullText = el.textContent || '';
				const hasArabic = containsArabic(fullText);

				// For Arabic on iPad: use clip-path animation instead of splitting characters
				// This keeps text intact and avoids breaking Arabic letter connections
				if (hasArabic && isTablet()) {
					el.__isArabicTablet = true;
					el.__typewriterPrepared = true;
					// Mark the element for CSS-based animation
					el.classList.add('typewriter-arabic-tablet');

					// Find and prepare child lines - hide them immediately
					const lines = el.querySelectorAll(':scope > span, :scope > p');
					lines.forEach((line) => {
						line.classList.add('typewriter-arabic-line');
					});

					// Store whether we have child lines or not
					el.__hasChildLines = lines.length > 0;

					// If no child lines, add class to hide the container initially
					if (!el.__hasChildLines) {
						el.classList.add('typewriter-arabic-no-children');
					}

					return;
				}

				// Wrap text nodes into character spans while preserving inline tags
				function wrapNode(node) {
					if (node.nodeType === Node.TEXT_NODE) {
						const frag = document.createDocumentFragment();
						const text = node.textContent || '';

						// Non-Arabic text OR Arabic on desktop: character-by-character approach
						for (let i = 0; i < text.length; i++) {
							const ch = text[i];
							// Keep whitespace as plain text nodes to preserve word spacing immediately
							if (/\s/.test(ch)) {
								frag.appendChild(document.createTextNode(ch));
								continue;
							}
							const span = document.createElement('span');
							span.className = 'typewriter-char';
							span.textContent = ch;
							frag.appendChild(span);
						}
						return frag;
					} else if (node.nodeType === Node.ELEMENT_NODE) {
						const clone = node.cloneNode(false);
						const children = Array.from(node.childNodes).map(wrapNode);
						children.forEach((c) => clone.appendChild(c));
						return clone;
					}
					return null;
				}
				const nodes = Array.from(el.childNodes).map(wrapNode).filter(Boolean);
				el.innerHTML = '';
				nodes.forEach((n) => el.appendChild(n));
				el.__typewriterPrepared = true;
			}

			function resetParagraph(el) {
				if (!el) return;
				clearTimers();
				if (el.__originalHTML != null) {
					el.innerHTML = el.__originalHTML;
				}
				// Remove Arabic tablet classes if present
				el.classList.remove('typewriter-arabic-tablet', 'typewriter-arabic-tablet-animate', 'typewriter-arabic-no-children');
				// Also clean up any line-level classes and styles
				el.querySelectorAll('.typewriter-arabic-line').forEach((line) => {
					line.classList.remove('typewriter-arabic-line', 'typewriter-arabic-line-animate');
					line.style.animationDelay = '';
					line.style.webkitAnimationDelay = '';
				});
				delete el.__typewriterPrepared;
				delete el.__originalHTML;
				delete el.__isArabicTablet;
				delete el.__hasChildLines;
			}

			function playTypewriter(el) {
				if (!el) return;
				prepareParagraph(el);

				// Special handling for Arabic on iPad/tablet - use CSS animation instead
				if (el.__isArabicTablet) {
					el.classList.add('typewriter-active');

					// Check if we have child lines or animate the whole container
					if (el.__hasChildLines) {
						// Find child elements with the typewriter-arabic-line class
						const lines = Array.from(el.querySelectorAll('.typewriter-arabic-line'));

						if (lines.length > 0) {
							// Animate lines one by one using animationend event
							let currentIndex = 0;

							function animateNextLine() {
								if (currentIndex >= lines.length) return;

								const line = lines[currentIndex];

								// Listen for animation end to trigger next line
								if (currentIndex < lines.length - 1) {
									line.addEventListener(
										'animationend',
										function onEnd() {
											line.removeEventListener('animationend', onEnd);
											currentIndex++;
											animateNextLine();
										},
										{ once: true }
									);
								}

								// Start this line's animation
								line.classList.add('typewriter-arabic-line-animate');
							}

							// Start with the first line
							animateNextLine();
						}
					} else {
						// No child lines - animate the whole container
						el.classList.add('typewriter-arabic-tablet-animate');
					}
					return;
				}

				// Gather all character spans in DOM order
				const chars = el.querySelectorAll('.typewriter-char');
				// Add a cursor element
				let cursor = document.createElement('span');
				cursor.className = 'typewriter-cursor';
				// place cursor after first char if exists to keep it inline
				if (chars[0]) {
					chars[0].insertAdjacentElement('afterend', cursor);
				} else {
					el.appendChild(cursor);
				}

				// timings - same speed for all languages (character by character)
				const cps = 25; // characters per second
				const step = Math.max(8, Math.floor(1000 / cps));

				// reveal sequentially (no initialDelay - caller controls when to start)
				chars.forEach((span, idx) => {
					const t = setTimeout(() => {
						span.classList.add('visible');
						// move cursor to immediately after this character so it stays inline
						span.insertAdjacentElement('afterend', cursor);
					}, idx * step);
					typewriterTimers.push(t);
				});
				// remove cursor when done and ensure everything is visible
				const doneAt = chars.length * step + 150;
				const endT = setTimeout(() => {
					cursor.remove();
				}, doneAt);
				typewriterTimers.push(endT);
			}

			function handleHeaderAnimation() {
				// Reset all headings to ready state
				const allSlides = swiper && swiper.slides ? swiper.slides : slideshow.querySelectorAll('.swiper-slide');
				Array.from(allSlides).forEach((s) => {
					const h = s.querySelector('.banner__heading');
					if (!h) return;
					h.classList.remove('header-slide-in');
					h.classList.add('header-slide-ready');
				});
				const active = swiper && Number.isInteger(swiper.activeIndex) ? swiper.slides[swiper.activeIndex] : slideshow.querySelector('.swiper-slide-active');
				if (!active) return;
				const heading = active.querySelector('.banner__heading');
				if (heading) {
					// Defer class toggle across two frames to avoid initial stuck state
					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							heading.classList.remove('header-slide-ready');
							heading.classList.add('header-slide-in');
						});
					});
				}
			}

			function preHideForTransitionStart() {
				// Ensure incoming/new active slide content is hidden during the movement
				const slides = slideshow.querySelectorAll('.swiper-slide');
				slides.forEach((s) => {
					const h = s.querySelector('.banner__heading');
					if (h) {
						h.classList.remove('header-slide-in');
						h.classList.add('header-slide-ready');
					}
					const p = s.querySelector('.banner__text');
					if (p) {
						p.classList.remove('typewriter-active');
					}
				});
			}

			function handleTextAnimations() {
				const enableTextAnimations = e.dataset.enableTextAnimations === 'true';
				const enableTypewriter = e.dataset.enableTypewriter === 'true';
				const enableHeader = e.dataset.enableHeaderSlide === 'true';

				// On mobile: actively remove all animation classes and reset
				if (window.innerWidth < 750) {
					clearTimers();
					// Remove all header animation classes
					const allSlides = slideshow.querySelectorAll('.swiper-slide');
					allSlides.forEach((slide) => {
						const heading = slide.querySelector('.banner__heading');
						if (heading) {
							heading.classList.remove('header-slide-in', 'header-slide-ready');
							heading.style.opacity = '';
							heading.style.transform = '';
						}
						const paragraph = slide.querySelector('.banner__text');
						if (paragraph) {
							paragraph.classList.remove('typewriter-active');
							resetParagraph(paragraph);
						}
					});
					return;
				}

				// Desktop: proceed with animations
				// Always handle header animation independently
				if (enableHeader) handleHeaderAnimation();
				// If text animations are disabled, skip typewriter logic
				if (!enableTextAnimations) return;
				const slides = slideshow.querySelectorAll('.swiper-slide');
				slides.forEach((s) => {
					const p = s.querySelector('.banner__text');
					if (p && !s.classList.contains('swiper-slide-active')) {
						// reset inactive paragraphs to original state
						resetParagraph(p);
						p.classList.remove('typewriter-active');
					}
				});
				const activeSlide = slideshow.querySelector('.swiper-slide-active');
				if (!activeSlide) return;
				if (enableTypewriter) {
					const bannerText = activeSlide.querySelector('.banner__text');
					if (bannerText) {
						clearTimers();
						// ensure fresh state; prepare and play
						if (!bannerText.__typewriterPrepared) {
							prepareParagraph(bannerText);
						}
						// hide all chars before starting
						bannerText.querySelectorAll('.typewriter-char').forEach((c) => c.classList.remove('visible'));
						// reveal container now that we're ready to animate
						bannerText.classList.add('typewriter-active');

						// Delay typewriter start until AFTER header animation completes (if header is enabled)
						const headerAnimDuration = enableHeader ? 800 : 0; // header slideInFromBottom is 0.8s
						const typewriterStartDelay = headerAnimDuration + 100; // small buffer after header finishes

						const startTimer = setTimeout(() => {
							playTypewriter(bannerText);
						}, typewriterStartDelay);
						typewriterTimers.push(startTimer);
					}
				}
			}

			// Initial run and event wiring
			// Delay initial animation slightly to ensure slide is fully placed
			setTimeout(handleTextAnimations, 60);
			if (swiper) {
				// Hide incoming content during movement
				swiper.on('slideChangeTransitionStart', preHideForTransitionStart);
				// Start animations only after transition completes
				swiper.on('slideChangeTransitionEnd', handleTextAnimations);
			}
		})();

		// Prevent zoom/pinch gestures on mobile to keep slides contained
		if (window.innerWidth < 750 && slideshow) {
			// Simple approach: just prevent all multi-touch and let viewport meta handle zoom
			slideshow.addEventListener(
				'touchstart',
				function (event) {
					if (event.touches.length > 1) {
						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
					}
				},
				{ passive: false, capture: true }
			);

			slideshow.addEventListener(
				'touchmove',
				function (event) {
					if (event.touches.length > 1) {
						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
					}
				},
				{ passive: false, capture: true }
			);

			slideshow.addEventListener(
				'touchend',
				function (event) {
					// Prevent double-tap zoom
					if (event.timeStamp - (slideshow.lastTouchEnd || 0) < 300) {
						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
					}
					slideshow.lastTouchEnd = event.timeStamp;
				},
				{ passive: false, capture: true }
			);

			// Prevent gesture events on slideshow
			['gesturestart', 'gesturechange', 'gestureend'].forEach(function (eventName) {
				slideshow.addEventListener(
					eventName,
					function (e) {
						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();
					},
					{ passive: false, capture: true }
				);
			});
		}

		return swiper; // Return swiper instance for debugging
	}
	return Slider;
})();
